import { takeLatest, call, put, select } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import {
  sync,
  syncRequest,
  syncSuccess,
  syncFailure,
  setPendingChangesFlag
} from '../actions/ui/sync';
import {
  saveAccountSuccess,
  removeAccountSuccess
} from '../actions/entities/accounts';
import {
  saveTransactionSuccess,
  removeTransactionSuccess
} from '../actions/entities/transactions';
import { loadAccountsSaga } from './accounts';
import { loadTagsSaga } from './tags';
import { loadRecentTransactionsSaga } from './transactions';
import { isDemoUser, isSignedIn } from 'features/user/state/User.selector';
import { signInSuccess } from 'features/user/state/User.action';
import AccountsStorage from '../util/storage/accounts';
import TransactionsStorage from '../util/storage/transactions';
import TagsStorage from '../util/storage/tags';
import SettingsStorage from '../util/storage/settings';
import { remoteAccountsDB } from '../util/storage/pouchdb';

export function* syncSaga() {
  yield put(syncRequest());
  try {
    if (!remoteAccountsDB()) {
      const signedIn = yield select(isSignedIn);
      throw new Error(
        signedIn
          ? "Cloud sync isn't set up for your account yet. Sign out and sign in again to enable sync. If it still doesn't work, ensure the Auth0 Post Login Action is deployed (see deployment notes)."
          : 'Sign in to sync your data with the cloud. Cloud sync is only available when you are signed in.'
      );
    }
    const readOnly = yield select(isDemoUser);
    yield call(SettingsStorage.sync, readOnly);
    yield call(AccountsStorage.sync, readOnly);
    yield call(TransactionsStorage.sync, readOnly);
    yield call(TagsStorage.sync, readOnly);
    yield loadRecentTransactionsSaga();
    yield loadAccountsSaga();
    yield loadTagsSaga();
    yield put(syncSuccess());
  } catch (error) {
    yield put(syncFailure(error));
  }
}

export function* setPendingChangesFlagSaga() {
  yield put(setPendingChangesFlag());
}

export default [
  takeLatest(sync, syncSaga),
  takeLatest(getType(signInSuccess), syncSaga),
  takeLatest(saveAccountSuccess, setPendingChangesFlagSaga),
  takeLatest(removeAccountSuccess, setPendingChangesFlagSaga),
  takeLatest(saveTransactionSuccess, setPendingChangesFlagSaga),
  takeLatest(removeTransactionSuccess, setPendingChangesFlagSaga)
];
